const imageTextParallax = ({ el }) => {
   const header = document.querySelector('[data-header]');
   const headerHeight = header.offsetHeight;
   const screenHeight = window.innerHeight - headerHeight;

   const spacer = el.previousElementSibling;
   const imageWindow = spacer.querySelector('[data-image-text-parallax-image-container]');
   
   let widthDivider = 4;
   let heightDivider = 1.25;
   const endingWidth = 100;
   const endingHeight = 100;

   if (window.innerWidth < 1024) {
      widthDivider = 1.5;
      heightDivider = 1.5;
   }

   const updateBackgroundState = () => {
      const position = el.getBoundingClientRect();
      const backgroundImage = el.querySelector('[data-image-text-parallax-background]');
      if (position.top < 97) {
         backgroundImage.classList.remove('opacity-0');
      } else {
         backgroundImage.classList.add('opacity-0');
      }
   }

   const determineWidth = () => {
      
      const startingWidth = endingWidth / widthDivider;
      const spacerTop = spacer.offsetTop - headerHeight;
      const spacerHeight = spacer.offsetHeight - spacerTop;
      const scrollPosition = document.scrollingElement.scrollTop;

      const widthDifference = endingWidth - startingWidth;
      const yAxisCalculations = ((scrollPosition - spacerTop) / (spacerHeight - spacerTop));

      return (widthDifference * yAxisCalculations) + startingWidth;
   }

   const determineHeight = () => {
      const startingHeight = endingHeight / heightDivider;
      const spacerTop = spacer.offsetTop - headerHeight;
      const spacerHeight = spacer.offsetHeight - spacerTop;
      const scrollPosition = document.scrollingElement.scrollTop;

      const heightDifference = endingHeight - startingHeight;
      const yAxisCalculations = ((scrollPosition - spacerTop) / (spacerHeight - spacerTop));

      return (heightDifference * yAxisCalculations) + startingHeight;
   }

   const updateImageContainerState = () => {
      const imageContainer = el.previousElementSibling;
      const imageContainerPosition = imageContainer.getBoundingClientRect();
      if (imageContainerPosition.top <= (headerHeight + headerHeight - screenHeight)) {
         imageWindow.style.width = `100%`;
         imageWindow.style.height = `100%`;
      } else if (imageContainerPosition.top >= 97) {
         imageWindow.style.width = `${endingWidth / widthDivider}%`;
         imageWindow.style.height = `${endingHeight / heightDivider}%`;
      } else {
         imageWindow.style.width = `${determineWidth()}%`;
         imageWindow.style.height = `${determineHeight()}%`;
      }
   }

   const scrollSnap = () => {
      const mainContent = el.querySelector('[data-image-text-parallax-main-content]');
      const elementTopPostition = getElemDistance(mainContent);
      const html = document.querySelector('html');
      html.style.scrollBehavior = 'auto';

      $('html, body').animate({
         scrollTop: elementTopPostition
      }, 3000);

      setTimeout(() => {
         html.style.scrollBehavior = 'smooth';
      }, 3500);
   }

   var getElemDistance = function ( elem ) {
      var location = 0;
      if (elem.offsetParent) {
         do {
            location += elem.offsetTop;
            elem = elem.offsetParent;
         } while (elem);
      }
      return location >= 0 ? location : 0;
   };


   let runScrollSnap = true;
   updateBackgroundState();
   updateImageContainerState();
   window.onscroll = function(){
      updateBackgroundState();
      updateImageContainerState();
   };
   if (document.scrollingElement.scrollTop === 0) {
      setTimeout(() => {
         if (document.scrollingElement.scrollTop === 0) {
            scrollSnap();
            runScrollSnap = false;
         }
      }, 2000);
   }
   addEventListener("scroll", (event) => {
      const scrollPosition = document.scrollingElement.scrollTop;
      const mainContent = el.querySelector('[data-image-text-parallax-main-content]');
      const elementTopPostition = getElemDistance(mainContent);
      if (runScrollSnap) {
         if (scrollPosition < elementTopPostition) {
            scrollSnap();
         }
         runScrollSnap = false;
      }
   });
}

export default imageTextParallax;